import { hexToBigInt } from 'viem';
export function getPaymasterModifiedGas(args) {
    const { paymasterData } = args;
    const gas = {
        preVerificationGas: hexToBigInt(paymasterData.preVerificationGas),
        verificationGasLimit: hexToBigInt(paymasterData.verificationGasLimit),
        callGasLimit: hexToBigInt(paymasterData.callGasLimit),
        paymasterAndData: undefined,
        paymasterData: undefined,
        paymaster: undefined,
        paymasterVerificationGasLimit: undefined,
        paymasterPostOpGasLimit: undefined,
    };
    //////////////////////////////////////////////////////////////////
    // Add 06 fields
    //////////////////////////////////////////////////////////////////
    if ('paymasterAndData' in paymasterData) {
        gas.paymasterAndData = paymasterData.paymasterAndData;
    }
    //////////////////////////////////////////////////////////////////
    // Add 07 fields
    //////////////////////////////////////////////////////////////////
    if ('paymaster' in paymasterData) {
        gas.paymaster = paymasterData.paymaster;
    }
    if ('paymasterData' in paymasterData) {
        gas.paymasterData = paymasterData.paymasterData;
    }
    if ('paymasterVerificationGasLimit' in paymasterData) {
        gas.paymasterVerificationGasLimit = hexToBigInt(paymasterData.paymasterVerificationGasLimit);
    }
    if ('paymasterPostOpGasLimit' in paymasterData) {
        gas.paymasterPostOpGasLimit = hexToBigInt(paymasterData.paymasterPostOpGasLimit);
    }
    //////////////////////////////////////////////////////////////////
    // Add alchemy fields
    //////////////////////////////////////////////////////////////////
    if (paymasterData.maxFeePerGas && paymasterData.maxPriorityFeePerGas) {
        // alchemy returns these as well, so we need to set them here
        // https://docs.alchemy.com/reference/alchemy-requestgasandpaymasteranddata
        return {
            ...gas,
            maxFeePerGas: paymasterData.maxFeePerGas
                ? hexToBigInt(paymasterData.maxFeePerGas)
                : undefined,
            maxPriorityFeePerGas: paymasterData.maxPriorityFeePerGas
                ? hexToBigInt(paymasterData.maxPriorityFeePerGas)
                : undefined,
        };
    }
    return gas;
}
